var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPromoUrl = function SvgPromoUrl(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.305 12.0001C4.305 10.2983 5.6255 8.91488 7.25 8.91488H11.05V7.02393H7.25C4.628 7.02393 2.5 9.25326 2.5 12.0001C2.5 14.747 4.628 16.9763 7.25 16.9763H11.05V15.0854H7.25C5.6255 15.0854 4.305 13.702 4.305 12.0001ZM8.2 12.9954H15.8V11.0049H8.2V12.9954ZM16.75 7.02393H12.95V8.91488H16.75C18.3745 8.91488 19.695 10.2983 19.695 12.0001C19.695 13.702 18.3745 15.0854 16.75 15.0854H12.95V16.9763H16.75C19.372 16.9763 21.5 14.747 21.5 12.0001C21.5 9.25326 19.372 7.02393 16.75 7.02393Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPromoUrl);
export default ForwardRef;